import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

export interface InputDialogData {
  disableClose?: boolean;
  message?: string;
  subheader?: string;
  showInput?: boolean;
  okButtonLabel?: string;
}

@Component({
  selector: 'gt-input-dialog',
  templateUrl: './input-dialog.component.html',
  styleUrls: ['./input-dialog.component.scss']
})
export class InputDialogComponent {
  disableClose: boolean;
  message: string;
  subheader: string;
  showInput: boolean;
  response = '';
  okButtonLabel: string;

  constructor(@Inject(MAT_DIALOG_DATA) public data: InputDialogData, private dialogRef: MatDialogRef<InputDialogComponent>) {
    this.disableClose = this.data.disableClose;
    this.message = this.data.message;
    this.subheader = this.data.subheader;
    this.showInput = this.data.showInput;
    this.okButtonLabel = this.data.okButtonLabel ? this.data.okButtonLabel : 'global.ok';
  }

  okClicked() {
    if (!this.showInput) {
      this.response = 'ok';
    }
    this.dialogRef.close(this.response);
  }

  cancelClicked() {
    this.dialogRef.close();
  }
}
